import type { IconData } from '@stacksjs/iconify-core'

export const friedEggBreakfastRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1C10.627 1 1 12.994 1 27c0 10.453 6.84 20 16.219 20c3.407 0 6.535-1.276 9.094-3.388c2.119-1.749 4.972-2.578 7.647-2.578c7.596 0 13.04-7.52 13.04-15.81C47 13.194 38.881 1 24 1M5 27C5 14.624 13.373 5 24 5c12.119 0 19 9.806 19 20.224c0 6.963-4.442 11.81-9.04 11.81c-3.419 0-7.226 1.044-10.193 3.493C21.837 42.12 19.59 43 17.219 43C10.892 43 5 36.193 5 27m19-15.455c-5.824 0-10.546 4.721-10.546 10.545c0 5.825 4.722 10.546 10.546 10.546s10.545-4.721 10.545-10.546S29.824 11.545 24 11.545m-.5 5.728a1.5 1.5 0 0 1 1.5-1.5a5.32 5.32 0 0 1 5.318 5.319a1.5 1.5 0 0 1-3 0A2.32 2.32 0 0 0 25 18.773a1.5 1.5 0 0 1-1.5-1.5\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default friedEggBreakfastRemix
